"use client"

import { Button } from "@/components/ui/button"

export function GoBackButton() {
  return (
    <Button
      variant="ghost"
      onClick={() => window.history.back()}
      className="font-display text-[var(--tls-fg-muted)] hover:text-[var(--tls-fg-strong)] transition-colors"
    >
      Go back
    </Button>
  )
}
